import _ from 'underscore';
import { ODataAdaptor } from './js-data-odata';

let ajaxOptions;

export class MmcDataSource {
  static init({
    aid, cid, uid, host, oDataToken, error,
  }) {
    ajaxOptions = {
      aid, cid, uid, host, oDataToken, error,
    };
  }

  constructor({
    routePrefix,
    endpoint,
    entityName,
    idAttribute,
    noScope,
    getODataURLWithKey,
  }) {
    if (!ajaxOptions) {
      throw new Error('MmcDataSource is not initialized');
    }
    this.odataAdapter = new ODataAdaptor();
    this.odataURL = this.getODataURL(routePrefix, endpoint, entityName);
    this.getODataURLWithKey = getODataURLWithKey || this.defaultGetODataURLWithKey(this.odataURL);
    this.noScope = noScope;
    this.entity = {
      class: entityName,
      name: entityName,
      endpoint: entityName,
      // Used by js-data-odata-base-adapter
      // Refer: AdsAppUISharedComponents/private/client-data/packages/
      //   js-data-odata-base-adapter/src/index.es
      idAttribute,
    };
    // Used by grid data source
    // Refer: AdsAppUISharedComponents/private/client-projection-grid/packages/
    //   projection-grid/src/data-source/js-data.js
    this.idAttribute = idAttribute;

    this.options = _.defaults({ ajaxOptions }, {
      // This is some stub code which is required by the js-data-odata module.
      edm: {
        types: {
          ActionType: class ActionType { },
        },
      },
      headers: {
        'x-bmcapi-ClientTrackingId': '',
        'x-bmcapi-PartnerId': 'AD005447-0B3A-4AE5-8BF7-4CA6E28BD23B',
      },
      xhrFields: {
        withCredentials: true,
      },
    });

    // Memoizing results returns the same results if the parameters are the same
    // Enabling disables sorting in grid
    // Revisiting in future
    // this.findAll = _.memoize(this.findAll);
  }

  withScope() {
    const {
      aid, cid, uid,
    } = ajaxOptions;
    return `Users(${uid})/Customers(${cid})/Accounts(${aid})/`;
  }

  getODataURL(routePrefix, endpoint, entityName) {
    const {
      host,
    } = ajaxOptions;
    return `${host}${routePrefix}${this.noScope? '': this.withScope()}${endpoint}${entityName}`;
  }

  defaultGetODataURLWithKey(odataURL) {
    return ({ key }) => `${odataURL}(${key})`;
  }

  getOptions(options) {
    const entitySet = {
      odataURL: this.odataURL,

      // This is another stub code which is required by the js-data-odata module.
      navigation: {
        source: {
          type: {

          },
        },
      },

      $withKey: key => ({
        odataURL: this.getODataURLWithKey({ key }),
      }),
    };

    const finalOptions = _.defaults({}, options, { entitySet }, this.options);

    return finalOptions;
  }

  find(id, options) {
    return this.odataAdapter.find(this.entity, id, this.getOptions(options));
  }

  findAll(params, { afterFindAll, ...options } = {}) {
    return this.odataAdapter
      .findAll(this.entity, params, this.getOptions(options))
      .then(data => (_.isFunction(afterFindAll) ? afterFindAll(this.entity, data) : data))
      .then((data) => {
        if (_.isArray(data)) {
          return data;
        }
        throw data;
      });
  }

  get(id, options) {
    return this.odataAdapter.get(this.entity, id, this.getOptions(options));
  }

  create(data, options) {
    return this.odataAdapter.create(this.entity, data, this.getOptions(options));
  }

  update(id, data, options) {
    return this.odataAdapter.update(this.entity, id, data, this.getOptions(options));
  }

  post(id, data, options) {
    return this.odataAdapter.post(this.entity, id, data, this.getOptions(options));
  }

  delete(id, options) {
    return this.odataAdapter.delete(this.entity, id, this.getOptions(options));
  }
}
